module.exports = __webpack_public_path__ + "static/media/Investor-CHRIS_DREES_P&A_SOLO_FINAL_1646357040623.b755d379.vtt";